import { appendElement } from '../xml-helpers';

export function buildCitationList(
  parent: Element,
  references: string | undefined,
  emitEmpty = false
): Element | null {
  const lines = (references ?? '')
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0);

  if (lines.length === 0) {
    return emitEmpty ? appendElement(parent, 'citation_list') : null;
  }

  const citationList = appendElement(parent, 'citation_list');

  lines.forEach((line, index) => {
    const citation = appendElement(citationList, 'citation', null, {
      // Use a 1-based index for the ref key to match common citation numbering conventions
      key: `ref${index + 1}`,
    });
    appendElement(citation, 'unstructured_citation', line);
  });

  return citationList;
}
